<template>
  <div class="left-search tree-container">
    <div class="serach">
      <div class="tip"></div>
      <el-input
        :placeholder="currentIndex == 'type' ? $t('searchTypeName') : $t('searchUsername')"
        clearable
        v-model="query.mediaTypeName"
      >
      </el-input>
    </div>
    <elTree2
      ref="cateTree"
      :data="mechanismData"
      :check-on-click-node="false"
      :default-checked-keys="checkedList"
      show-checkbox
      node-key="mediaTypeId"
      :filter-node-method="filterNode"
      default-expand-all
      :check-strictly="true"
      :props="ouTreeProps"
      @check="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <template>
          <i class="leaf-node-line" v-if="firstNode.id !== node.data.id"></i>
          <span>
            <span class="tenant" v-if="!node.data.path">{{ node.data.name }}</span>
            <span class="node-txt" v-else>{{ node.data.name }}</span>
          </span>
        </template>
      </span>
    </elTree2>
    <div class="cate-btn">
      <div class="tip-sify">
        <p>
          {{ $t('selectedFilesIinto') }} <span> 【{{ checkNode.name }}】</span> {{ $t('category') }}
        </p>
        <el-button size="small" @click="saveCate('back')" class="back-btn"> {{ $t('exitClassificat') }}</el-button>
        <el-button type="primary" @click="saveCate('save')" class="serachBtn" size="small">{{ $t('save') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import elTree2 from '@/components/vTree/src/tree'
import { attributeTree } from '@/api/new-device/categoryAttribut'
export default {
  data() {
    return {
      currentIndex: 'type',
      query: {
        mediaTypeName: '',
      },
      mechanismData: [],
      // 机构树格式
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      checkedList: [],
      checkNode: { name: '' },
      firstNode: null,
    }
  },
  components: {
    elTree2,
  },
  watch: {
    // 机构树搜索用户名/名字监听
    'query.mediaTypeName'(val) {
      this.query.mediaTypeName = val
      this.$refs.cateTree.filter(val)
    },
  },
  methods: {
    saveCate(type) {
      this.$emit('handleCate', type)
    },
    handleClear() {
      this.checkedList = []
      this.getOusTree()
    },
    // 获取类别归属树数据
    getOusTree() {
      let param = {
        isContainMediaType: 0,
        name: this.query.mediaTypeName,
        isReject: 0, // // 1:不包含 0:包含
      }
      attributeTree(param).then(res => {
        if (res.state === 0) {
          this.mechanismData = res.value
          this.firstNode = res.value && res.value[0] ? res.value[0] : null
        }
      })
    },
    // 当前类别
    handleNodeClick(data, checked, node) {
      if (checked) {
        this.checkNode = data
        this.$emit('handletypeNode', data)
        let arr = [data.mediaTypeId]
        this.$nextTick(() => {
          this.$refs.cateTree.setCheckedKeys(arr)
        })
      } else {
        this.checkNode = { name: '' }
      }
    },
    // 节点过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  },
  mounted() {
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.left-search
  width: 20%
  height: 100%
  background-color: #eff1f4;
  margin-left: 20px
  position relative
  >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
    color: #2372df !important;
  .cate-btn
    position absolute
    bottom: 0
    left: 0
    background #f7f8fa
    overflow hidden
    width: 100%
    padding-bottom: 10px
    .tip-sify
      float: right
      margin: 0 10px
      font-size: 14px
      color: #222
      p
        margin: 5px 0
        span
          margin: 0 5px
          color: #00A0E9
    .el-button
      float: right
      margin-left: 10px
    .el-button--small
      padding: 5px 10px;/*no*/
  .el-tree
    height: 79%;
    overflow: auto;
    border-top: var(--aside-tree-border-bottom);
    color: var(--table-color);
    background: #eff1f4
    .custom-tree-node
      width: 90%;
      span
        display: inline-block
        width: 100%
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
  .serach
    display: flex
    align-items: center
    padding: 10px 0!important
    background: #e3e7ed
    .tip
      width: 5px
      height: 30px
      margin-left: 16px
      margin-right: 10px
      background: #0e65dd
      border-radius: 4px
    >>>.el-input
      width: 82%!important
      vertical-align: middle
      .el-input__inner
        border-radius: 6px
        border: 1px solid var(--boredr-color)
        background-color: #fff
        color: #333
        font-size: 14px
        padding: 0 10px
        height: 36px;/*no*/
        line-height: 36px;/*no*/
        &::placeholder
          color: #999
  .dataStaticTree
    margin-left: 10px
    margin-top: 14px
    height: 90%
    overflow: auto
  >>>.el-tree-node__content>label.el-checkbox
    position: static !important
  .node-txt
    font-size 16px;/*no*/
    color: #222;
    font-weight: 600;
  .tenant
    font-size 16px;/*no*/
.theme-dark
  .left-search
    background-color: #042a85;
    >>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content
      color: #fff !important;
    .serach
      background: #002799
    .el-tree
      background: transparent
    .cate-btn
      background #0536b6
      .tip-sify
        color: #fff
        p
          span
            color: #00A0E9
    .back-btn
      color: #fff;
      background: #001143;
      border: 1px solid #295aff;
    .node-txt
      color: #fff;
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.tree-container /deep/ .el-tree-node {
   position: relative;
   padding-left: 13px;
 }

 // 设置树形组件节点的 before 伪类的样式
 .tree-container /deep/ .el-tree-node:before {
   width: 1px;
   height: 100%;
   content: '';
   position: absolute;
   top: -38px;
   bottom: 0;
   left: 0;
   right: auto;
   border-width: 1px;
   border-left: 1px solid #B8C3D4;
 }

 // 设置树形组件节点的 after 伪类的样式
 .tree-container /deep/ .el-tree-node:after {
   width: 13px;
   height: 13px;
   content: '';
   position: absolute;
   left: 0;
   right: auto;
   top: 12px;
   bottom: auto;
   border-width: 1px;
   border-top: 1px solid #B8C3D4;
 }

 // 设置树形组件首节点的左边框不显示
 .tree-container /deep/ .el-tree > .el-tree-node:before {
   border-left: none;
 }

 // 设置树形组件首节点的顶部边框不显示
 .tree-container /deep/ .el-tree > .el-tree-node:after {
   border-top: none;
 }

 // 设置树形组件末节点的 before 伪类的高度
 .tree-container /deep/ .el-tree .el-tree-node:last-child:before {
   height: 50px;
 }

 // 设置树形组件节点字体大小、以及取消左内边距
 .tree-container /deep/ .el-tree .el-tree-node__content {
   font-size: 14px;
   padding-left: 0 !important;
 }

 // 设置树形组件孩子节点左内边距
 .tree-container /deep/ .el-tree .el-tree-node__children {
   padding-left: 11.5px;
 }

 // 设置树形组件复选框左右外边距
 .tree-container /deep/ .el-tree .el-tree-node__content > label.el-checkbox {
   margin: 0 5px 0 5px !important;
 }

 // 设置树形组件展开图标定位、图层、内边距
 .tree-container /deep/ .el-tree .el-tree-node__expand-icon {
   position: relative;
   z-index: 99;
 }

 // 设置树形组件叶子节点的默认图标不显示
 .tree-container /deep/ .el-tree .el-tree-node__expand-icon.is-leaf {
   display: none;
 }

 // 设置树形组件叶子节点的横线
 .tree-container /deep/ .el-tree .leaf-node-line {
   width: 8px;
   height: 13px;
   content: '';
   position: absolute;
   left: 13px;
   right: auto;
   top: 12px;
   bottom: auto;
   border-width: 1px;
   border-top: 1px solid #B8C3D4;
 }

 // 设置树形组件有叶子节点的左外边距
 .tree-container /deep/ .el-tree .el-tree-node__content:has(.is-leaf){
   // color: aqua;
   padding-left: 10px !important;
 }
 .theme-dark
  .tree-container /deep/ .el-tree-node:before {
    border-left: 1px solid #057efa;
  }

  // 设置树形组件节点的 after 伪类的样式
  .tree-container /deep/ .el-tree-node:after {
    border-top: 1px solid #057efa;
  }
  // 设置树形组件叶子节点的横线
  .tree-container /deep/ .el-tree .leaf-node-line {
    border-top: 1px solid #057efa;
  }
  .tree-container /deep/ .el-tree > .el-tree-node:before {
    border-left: none;
  }

  // 设置树形组件首节点的顶部边框不显示
  .tree-container /deep/ .el-tree > .el-tree-node:after {
    border-top: none;
  }
</style>
